import React, { useState, useRef, useEffect } from 'react';
import './AIChatbot.css';

const AIChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: 'Hello! I\'m Rivo. How can I help you today?',
      timestamp: new Date()
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) return;

    const userMessage = {
      type: 'user',
      text: inputValue,
      timestamp: new Date()
    };

    setMessages(prev => [...prev, userMessage]);
    setInputValue('');
    setIsTyping(true);

    // Simulate AI response (replace with actual API call)
    setTimeout(() => {
      const responses = [
        'That\'s a great question! Let me help you with that. Our AI-driven cybersecurity solutions can protect your enterprise infrastructure.',
        'I\'d be happy to assist! Rivontrix offers cutting-edge Generative AI solutions and digital transformation services.',
        'Excellent! Our ShieldEx product provides AI-driven cybersecurity protection. Would you like to schedule a demo?',
        'Great to hear from you! We specialize in AI-powered security, cloud migration, and talent solutions. How can we help?',
        'Thank you for your interest! Our team of experts can help transform your business with intelligent defense solutions.'
      ];
      
      const botMessage = {
        type: 'bot',
        text: responses[Math.floor(Math.random() * responses.length)],
        timestamp: new Date()
      };

      setMessages(prev => [...prev, botMessage]);
      setIsTyping(false);
    }, 1000 + Math.random() * 1000);
  };

  const quickActions = [
    { text: 'Learn about ShieldEx', action: () => handleQuickAction('Tell me about ShieldEx') },
    { text: 'Request Demo', action: () => handleQuickAction('I want to request a demo') },
    { text: 'Contact Sales', action: () => handleQuickAction('I want to contact sales') }
  ];

  const handleQuickAction = (text) => {
    setInputValue(text);
    setTimeout(() => {
      handleSend({ preventDefault: () => {} });
    }, 100);
  };

  return (
    <>
      <button
        className={`ai-chatbot-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Open AI Chatbot"
      >
        <i className="fas fa-robot"></i>
        {!isOpen && <span className="pulse-dot"></span>}
      </button>

      {isOpen && (
        <div className="ai-chatbot-container">
          <div className="ai-chatbot-header">
            <div className="ai-chatbot-header-content">
              <div className="ai-avatar">
                <i className="fas fa-robot"></i>
                <span className="ai-status"></span>
              </div>
              <div className="ai-chatbot-header-text">
                <h3>Rivo</h3>
                <p>Powered by Generative AI</p>
              </div>
            </div>
            <button
              className="ai-chatbot-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close Chatbot"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="ai-chatbot-messages">
            {messages.map((message, index) => (
              <div key={index} className={`message ${message.type}`}>
                <div className="message-content">
                  {message.type === 'bot' && (
                    <div className="message-avatar">
                      <i className="fas fa-robot"></i>
                    </div>
                  )}
                  <div className="message-bubble">
                    <p>{message.text}</p>
                    <span className="message-time">
                      {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            
            {isTyping && (
              <div className="message bot">
                <div className="message-content">
                  <div className="message-avatar">
                    <i className="fas fa-robot"></i>
                  </div>
                  <div className="message-bubble typing">
                    <div className="typing-indicator">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {messages.length === 1 && (
              <div className="quick-actions">
                {quickActions.map((action, index) => (
                  <button
                    key={index}
                    className="quick-action-btn"
                    onClick={action.action}
                  >
                    {action.text}
                  </button>
                ))}
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          <form className="ai-chatbot-input-form" onSubmit={handleSend}>
            <input
              ref={inputRef}
              type="text"
              className="ai-chatbot-input"
              placeholder="Ask me anything about Rivontrix..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <button type="submit" className="ai-chatbot-send" disabled={!inputValue.trim()}>
              <i className="fas fa-paper-plane"></i>
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default AIChatbot;

